'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = typeof window !== 'undefined' ? window.app : undefined;
class Image extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      id: 'image-' + ++app.images_id
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    window.objectFitImages(document.getElementById(state.id));
  }
  componentDidUpdate() {
    const component = this,
      props = this.props,
      state = this.state;
    window.objectFitImages(document.getElementById(state.id));
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    let output = /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
      className: props.className || 'u-responsive-img',
      id: state.id
    }, props));
    return output;
  }
}
exports.default = Image;
Image.propTypes = {
  src: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string,
  title: _propTypes.default.string,
  style: _propTypes.default.object
};
